<template>
    <footer class="footer">
        <div class="container">
            <div class="content has-text-centered">
                <p>Powered by Mahy Technologies<br>
                    <a href="#">Terms of Service</a> | <a href="#">Privacy Policy</a>
                </p>
            </div>
        </div>
    </footer>
</template>